import { computed } from 'vue';
import { useStore } from 'vuex';

export default function usePlanningsSelector() {
  const store = useStore();
  const plannings = computed(() => store.state.planning);

  const selectSingle = (id) => plannings.value[id];
  const select = (ids) => ids.map((uid) => plannings.value[uid]);

  return { selectSingle, select };
}
